module.exports = __webpack_public_path__ + "img/20-elon-illassa.1419b7a2.jpg";